import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export default function StatusDetails(props) {
  let ruppysymble = "\u20B9";
  const { transactionStatuswithAmount, sumOfallSatus } = props;
  return (
    <div class="parent">
      {transactionStatuswithAmount !== null &&
        transactionStatuswithAmount !== undefined &&
        transactionStatuswithAmount.length > 0 &&
        transactionStatuswithAmount.map((txnstatus, inde) => {
          const percentage =
            sumOfallSatus == 0 ? 0 : (txnstatus.count * 100) / sumOfallSatus;
          
          const statusColor =
            txnstatus?.id == "SUCCESS"
              ? "success"
              : txnstatus?.id == "FAILED"
              ? "danger"
              : txnstatus?.id == "PENDING"
              ? "warning"
              : "primary";
          const statusRailColor =
            txnstatus?.id == "SUCCESS"
              ? `rgba(25, 135, 84, 1)`
              : txnstatus?.id == "FAILED"
              ? `rgba(220, 53, 69, 1)`
              : txnstatus?.id == "PENDING"
              ? `rgba(255, 193, 7, 1)`
              : "00FFFF";
          return (
            <div key={inde} class="relative child">
              <span class={`badge badge-pill bg-${statusColor} mr-1`}>
                {/* {txnstatus?.id}  {txnstatus?.count} {`${ruppysymble}${txnstatus?.total}`} */}
                <p
                  style={{
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                >
                  {" "}
                  {txnstatus?.id}{" "}
                </p>{" "}
                <p
                  style={{
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                >
                  {txnstatus?.count}
                </p>{" "}
                {`${ruppysymble}${txnstatus?.total}`}
              </span>
              <div class="absolute">
                <CircularProgressbar
                  styles={buildStyles({
                    pathColor: statusRailColor,
                    textColor: statusRailColor,
                    trailColor: "#ccc",
                    backgroundColor: "#3e98c7",
                  })}
                  value={percentage}
                  text={`${percentage.toFixed(1)}%`}
                />
              </div>
            </div>
          );
        })}

      {/* <div class="relative child">
          <span class="badge badge-pill bg-danger mr-1">
            <p style={{ color: "#fff", fontWeight: "bold" }}> {"SUCCESS"} </p>{" "}
            <p style={{ color: "#fff", fontWeight: "bold" }}>{454545}</p>{" "}
            {<br />} {`${ruppysymble}${1000}`}
          </span>
          <div class="absolute">
            <CircularProgressbar
              styles={buildStyles({
                pathColor: `rgba(220, 53, 69, ${percentage / 100})`,
                textColor: "#f88",
                trailColor: "#ccc",
                backgroundColor: "#3e98c7",
              })}
              value={percentage}
              text={`${percentage}%`}
            />
          </div>
        </div> */}
    </div>
  );
}
